import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from '@portal/shared/ui/table';
import { DevicesTableTemplateComponent } from './devices-table-template.component';

@NgModule({
  imports: [CommonModule, TableModule],
  declarations: [DevicesTableTemplateComponent],
  exports: [DevicesTableTemplateComponent],
})
export class DevicesTableTemplateModule {}
